import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-4" }
const _hoisted_2 = { class: "field" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "content",
  class: "font-bold mb-2 block"
}, "내용", -1)
const _hoisted_4 = { class: "flex justify-between w-full px-4 pb-4" }

import { ref, watch } from "vue";
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import Textarea from "primevue/textarea";


export default /*#__PURE__*/_defineComponent({
  __name: 'ExampleModal',
  props: {
  visible: {
    type: Boolean,
    required: true,
  },
  initialContent: {
    type: String,
    default: "",
  },
  isEditing: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:visible", "save"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const content = ref(props.initialContent);

watch(
  () => props.visible,
  (newVisible) => {
    if (newVisible) {
      content.value = props.initialContent;
    }
  }
);

const close = () => {
  emit("update:visible", false);
};

const save = () => {
  emit("save", content.value);
  close();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: props.visible,
    style: { width: '90%', maxWidth: '600px' },
    modal: true,
    closable: false,
    header: props.isEditing ? '게시글 예시 수정' : '게시글 예시 등록'
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(Button), {
          label: "취소",
          icon: "pi pi-times",
          onClick: close,
          class: "p-button-text"
        }),
        _createVNode(_unref(Button), {
          label: "저장",
          icon: "pi pi-check",
          onClick: save,
          autofocus: ""
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_unref(Textarea), {
            id: "content",
            modelValue: content.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((content).value = $event)),
            rows: "8",
            autoResize: "",
            class: "w-full"
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "header"]))
}
}

})